import { Box, Typography } from '@mui/material';
import moment from 'moment';
import 'moment/locale/es';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { CustomInfoContainer } from '../../../components/customInfoContainer/CustomInfoContainer';
import { formatCurrency } from '../../../utils/mathUtils';
import InfoRow from '../../MisVisitasCreation/components/components/InfoRow/InfoRow';

moment.locale('es');

const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1);

const LiquidacionMeses = ({ mes, totalMesAnteAnterior, totalMesAnterior }) => {
    const mesLiquidado = capitalize(moment().month(mes - 1).format('MMMM'));
    const mesPrevio = capitalize(moment().month(mes - 2).format('MMMM'));

    return (
        <CustomInfoContainer>
            <InfoRow
                label={`Liquidación total ${mesPrevio}: `}
                value={formatCurrency(totalMesAnteAnterior ?? 0)}
                invert
                sx={{ flexDirection: 'row', columnGap: 0.5, mb: 0 }}
            />
            <Typography component="span" fontSize="inherit" mx={0.5}>-</Typography>
            <InfoRow
                label={`Liquidación total ${mesLiquidado}: `}
                value={formatCurrency(totalMesAnterior ?? 0)}
                invert
                sx={{ flexDirection: 'row', columnGap: 0.5, mb: 0 }}
            />
        </CustomInfoContainer>
    );
};

export const PreLiquidacionHeader = ({
    mes = moment().month() + 1,
    totalMesAnterior,
    totalMesAnteAnterior,
    allowedWrite,
    cantidadSeleccionada = 0,
    handleClickDesestimar,
    handleClickAprobar
}) => {
    const sinSeleccion = cantidadSeleccionada === 0;

    return (
        <Box display="flex" justifyContent="flex-end" alignItems="center" columnGap={2} sx={{ flex: 1, ml: 2 }}>
            <LiquidacionMeses
                mes={mes}
                totalMesAnteAnterior={totalMesAnteAnterior}
                totalMesAnterior={totalMesAnterior}
            />

            {allowedWrite && (
                <Box display="flex" columnGap={2}>
                    <CustomButton
                        variant='outlined'
                        onClick={handleClickDesestimar}
                        disabled={sinSeleccion}
                    >
                        Desestimar
                    </CustomButton>
                    <CustomButton
                        variant='contained'
                        onClick={handleClickAprobar}
                        disabled={sinSeleccion}
                    >
                        Aprobar
                    </CustomButton>
                </Box>
            )}
        </Box>
    );
};